import { render, staticRenderFns } from "./OrgsList.vue?vue&type=template&id=652edcb8&scoped=true"
import script from "./OrgsList.vue?vue&type=script&lang=js"
export * from "./OrgsList.vue?vue&type=script&lang=js"
import style0 from "./OrgsList.vue?vue&type=style&index=0&id=652edcb8&prod&lang=scss"
import style1 from "./OrgsList.vue?vue&type=style&index=1&id=652edcb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652edcb8",
  null
  
)

export default component.exports